/*! data-type: toggle, toogle-group, highcontrastmode */
(function() {
  'use strict';

  /* toggle */
  // data-dest: toggle element querySelector
  // data-classname: toggle classname
  function toggle(event) {
    function findClosest(el, s) {
      var dest = null;
      do {
        dest = el.querySelector(s);
        if (dest) return dest;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    }
    let el = this;
    if (this.dataset.dest) {
      el = findClosest(el, this.dataset.dest);
    }
    if (!el) {
      el = this;
    }
    let className = (this.dataset.classname ? this.dataset.classname : 'hidden');
    el.classList.toggle(className);
  }

  // add event listener to all toggle elements
  let els = document.querySelectorAll("[data-type='toggle']");
  for (let i = 0; i < els.length; i++) {
    els[i].addEventListener('click', toggle);
  }

  /* togglegroup */
  // data-classname: toogle classname
  function tooglegroup (group) {
    var current = -1;
    var items = group.querySelectorAll("[data-type='toggle-item']");
    var trigger = group.querySelectorAll("[data-type='toggle-trigger']");
    function toggle(event) {
      trigger[current].classList.remove("active");
      items[current].classList.remove("active");
      current = this.itemid;
      trigger[current].classList.add("active");
      items[current].classList.add("active");
      event.stopPropagation();
    }
    for (var i=0; i<items.length; i++) {
      if (items[i].classList.contains("active")) {
        if (current > -1) {
          items[i].classList.remove("active");
        } else {
          current = i;
        }
      };
      trigger[i].setAttribute('tabindex', '0');
      if (i == current) {
        trigger[i].classList.add("active");
      } else {
        trigger[i].classList.remove("active");
      }
      trigger[i].itemid = i;
      trigger[i].addEventListener('click', toggle);
    }
  }
  // add event listener to all toggle elements
  els = document.querySelectorAll("[data-type='toggle-group']");
  for (let i = 0; i < els.length; i++) {
    new tooglegroup(els[i]);
  }
})();
